import { faqItems } from "@/mocks/home";

export default function SectionFAQ() {
  return (
    <section id="faq" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">常见问题</h2>
          <p className="mt-3 text-foreground-600 text-sm md:text-base">关于51视频，你关心的都在这里</p>
        </div>
        <div className="flex flex-col gap-4">
          {faqItems.map((item) => (
            <div
              key={item.id}
              className="bg-background-100 rounded-lg p-5 border border-background-200/70"
            >
              <h3 className="text-sm font-semibold text-foreground-900 mb-2">
                <span className="text-primary-500 mr-2">Q:</span>
                {item.q}
              </h3>
              <p className="text-xs text-foreground-700 leading-relaxed pl-6">
                <span className="text-secondary-500 mr-2">A:</span>
                {item.a}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}